import { render, staticRenderFns } from "./BadgesView.vue?vue&type=template&id=6aed72be&scoped=true&"
import script from "./BadgesView.vue?vue&type=script&lang=js&"
export * from "./BadgesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aed72be",
  null
  
)

export default component.exports